import { createFileRoute } from '@tanstack/react-router'
import { CreateTransactionPage } from '_/features/finance/ui/pages/create-transaction-page'

export const Route = createFileRoute('/_authenticated/finance/create')({
	staticData: { title: 'finance_new_title' },
	component: CreateTransactionPage,
})
